import { EyeTestLogic } from './eye-test-logic';
import { ContrastTestLogic } from './contrast-test-logic';
import { MichelsonTestLogic } from './michelson-test-logic';

export class TestLogicFactory {

    private static _eyeTestLogicInstance: EyeTestLogic;
    private static _contrastTestLogicInstance: ContrastTestLogic;
    private static _michelsonTestLogicInstance: MichelsonTestLogic;

    static getInstanceOf(
        type: 'eye-test-logic' | 'contrast-test-logic' | 'michelson-test-logic'
    ): EyeTestLogic | ContrastTestLogic | MichelsonTestLogic {
        if (type === 'eye-test-logic') {
            if (!TestLogicFactory._eyeTestLogicInstance) {
                TestLogicFactory._eyeTestLogicInstance = new EyeTestLogic();
            }
            return TestLogicFactory._eyeTestLogicInstance;
        } else if (type === 'contrast-test-logic') {
            if (!TestLogicFactory._contrastTestLogicInstance) {
                TestLogicFactory._contrastTestLogicInstance = new ContrastTestLogic();
            }
            return TestLogicFactory._contrastTestLogicInstance;
        } else {
            if (!TestLogicFactory._michelsonTestLogicInstance) {
                TestLogicFactory._michelsonTestLogicInstance = new MichelsonTestLogic();
            }
            return TestLogicFactory._michelsonTestLogicInstance;
        }
    }

}